export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#2E4A3E] py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <h4 className="text-xl md:text-2xl font-serif font-bold text-white mb-2">
              Laurie's Flash Framers
            </h4>
            <p className="text-white/80 text-sm leading-relaxed">
              Museum-Quality Custom Framing
            </p>
          </div>

          <div>
            <h5 className="text-white font-semibold mb-4">Quick Links</h5>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-white/70 hover:text-[#D4B137] transition-colors text-sm cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-white/70 hover:text-[#D4B137] transition-colors text-sm cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-white/70 hover:text-[#D4B137] transition-colors text-sm cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('portfolio')}
                  className="text-white/70 hover:text-[#D4B137] transition-colors text-sm cursor-pointer"
                >
                  Portfolio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-white/70 hover:text-[#D4B137] transition-colors text-sm cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-white font-semibold mb-4">Services</h5>
            <ul className="space-y-3">
              <li className="text-white/70 text-sm">Custom Framing</li>
              <li className="text-white/70 text-sm">Art Consultation</li>
              <li className="text-white/70 text-sm">Restoration</li>
              <li className="text-white/70 text-sm">Museum-Quality Materials</li>
            </ul>
          </div>

          <div>
            <h5 className="text-white font-semibold mb-4">Connect</h5>
            <div className="space-y-3 mb-6">
              <a
                href="https://www.google.com/maps/search/?api=1&query=Laurie's+Flash+Framers+Sherman+Oaks"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/70 hover:text-[#D4B137] transition-colors text-sm cursor-pointer"
              >
                <i className="ri-map-pin-line text-lg"></i>
                <span>Google Maps</span>
              </a>
              <a
                href="https://www.instagram.com/lauriesflashframers/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/70 hover:text-[#D4B137] transition-colors text-sm cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
                <span>Instagram</span>
              </a>
            </div>
            <p className="text-white/80 text-sm leading-relaxed">
              14005 Ventura Blvd<br />
              Sherman Oaks, CA 91423<br />
              San Fernando Valley
            </p>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm">
              © {new Date().getFullYear()} Laurie's Flash Framers. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
